/*
  Primal Viking · Early Access cart helper
  Shared add-to-cart for the Early Access LP sections (pv-ea-*). Same flow as
  pv-product-section.js / pv-otp-section.js: POST /cart/add.js with the
  mini-cart section, read the authoritative cart from /cart.js, then dispatch
  `cart:refresh` (detail.cart + openMiniCart) so the drawer re-renders and the
  header bubble updates, and open the drawer.

  Markup contract (delegated, works for any section on the page):
    <button type="button" data-pv-ea-atc
            data-variant-id="123" data-selling-plan="456" data-quantity="1">
  or, for several lines in one request:
    <button type="button" data-pv-ea-atc data-items='[{"id":123,"quantity":2}]'>

  Plain links to /cart/add?id=123&quantity=1[&selling_plan=456] (e.g. a
  section's URL setting that can't carry data attributes) are handled the
  same way; without JS they still work as Shopify's native add-and-go-to-cart.

  While the request runs the button gets aria-busy="true" + disabled. On
  failure it gets data-pv-ea-error with the Shopify message (style as needed).

  JS API: window.PVEarlyAccessCart.add(items) -> Promise<cart>
*/
(function () {
  if (window.PVEarlyAccessCart) return;

  function qsDrawer() {
    return document.querySelector('cart-drawer#mini-cart') ||
           document.querySelector('cart-drawer[section="mini-cart"]');
  }

  function getMiniCartSectionId() {
    var drawer = qsDrawer();
    return (drawer && drawer.getAttribute('section')) || 'mini-cart';
  }

  function normalizeMiniCartSections(sections) {
    if (!sections || sections['mini-cart']) return sections;
    var keys = Object.keys(sections);
    if (keys.length !== 1) return sections;
    var normalized = {};
    normalized['mini-cart'] = sections[keys[0]];
    return normalized;
  }

  function openMiniCart(cart, sections) {
    var payload = Object.assign({}, cart);
    if (sections) payload.sections = normalizeMiniCartSections(sections);

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: payload, openMiniCart: true }
    }));

    var drawer = qsDrawer();
    if (!drawer) return;
    try { drawer.open = true; } catch (e) { /* noop */ }
    drawer.setAttribute('open', '');
  }

  function add(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: getMiniCartSectionId(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          return body;
        });
      })
      .then(function (addBody) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            openMiniCart(cart, addBody.sections);
            return cart;
          });
      });
  }

  function itemsFromLink(link) {
    var url;
    try { url = new URL(link.href, window.location.origin); } catch (e) { return []; }
    if (url.origin !== window.location.origin || !/\/cart\/add\/?$/.test(url.pathname)) return [];

    var id = url.searchParams.get('id') || '';
    if (!/^\d+$/.test(id)) return [];

    var item = { id: Number(id), quantity: Number(url.searchParams.get('quantity')) || 1 };
    var sp = url.searchParams.get('selling_plan') || '';
    if (/^\d+$/.test(sp)) item.selling_plan = Number(sp);
    return [item];
  }

  function itemsFromButton(btn) {
    if (btn.matches('a[href]:not([data-pv-ea-atc])')) return itemsFromLink(btn);

    if (btn.dataset.items) {
      try {
        var parsed = JSON.parse(btn.dataset.items);
        if (Array.isArray(parsed)) return parsed.filter(function (i) { return i && i.id; });
      } catch (e) { /* fall through */ }
      return [];
    }

    var id = String(btn.dataset.variantId || '').trim();
    if (!/^\d+$/.test(id)) return [];

    var item = { id: Number(id), quantity: Number(btn.dataset.quantity) || 1 };
    var sp = String(btn.dataset.sellingPlan || '').trim();
    if (/^\d+$/.test(sp)) item.selling_plan = Number(sp);
    return [item];
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pv-ea-atc], a[href*="/cart/add"]');
    if (!btn) return;
    if (btn.getAttribute('aria-busy') === 'true') {
      e.preventDefault();
      return;
    }

    var items = itemsFromButton(btn);
    if (!items.length) {
      // Unparseable /cart/add link: let the browser follow it natively.
      if (!btn.hasAttribute('data-pv-ea-atc')) return;
      e.preventDefault();
      console.error('[PV Early Access] Missing/invalid variant id', btn);
      return;
    }
    e.preventDefault();

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.removeAttribute('data-pv-ea-error');

    add(items)
      .catch(function (err) {
        console.error('[PV Early Access ATC ERROR]', err);
        btn.setAttribute('data-pv-ea-error', (err && (err.description || err.message)) || 'error');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  });

  window.PVEarlyAccessCart = { add: add };
})();
